/*export const fetchDataDeteccionMaleza = async (areaMaleza, porcentajeMaleza, setDatosAnalisis) => {
    try {
        const datos = {
            areaMaleza: {
                titulo: "Área con maleza",
                valor: areaMaleza || 0
            },
            porcentajeMaleza: {
                titulo: "Porcentaje de maleza",
                valor: porcentajeMaleza || 0
            }
        };
        setDatosAnalisis(datos);
    } catch (error) {
        console.error("Error al cargar datos de Detección de Maleza:", error);
        setDatosAnalisis({});
    }
};*/

export const fetchDataDeteccionMaleza = async (areaMaleza, setDatosAnalisis, areaPoligono, porcentajeMaleza) => {
    try {
        // Verificar que setDatosAnalisis es una función
        if (typeof setDatosAnalisis !== 'function') {
            console.error('setDatosAnalisis is not a function:', setDatosAnalisis);
            return;
        }

        const datos = {
            areaPoligono: {
                titulo: "Área de polígonos",
                valor: areaPoligono || 0,
                unidad: "ha"
            },
            areaMaleza: {
                titulo: "Área con maleza",
                valor: areaMaleza || 0,
                unidad: "ha"
            },
            porcentajeMaleza: {
                titulo: "Porcentaje de área con maleza",
                valor: porcentajeMaleza || 0,
                unidad: "%"
            }
        };
        setDatosAnalisis(datos);
    } catch (error) {
        console.error("Error al cargar datos de Detección de Maleza:", error);
        if (typeof setDatosAnalisis === 'function') {
            setDatosAnalisis({});
        }
    }
};

export const shouldEnableExecBashDeteccionMaleza = (selectedZipFile) => {
    return selectedZipFile !== null;
};

export const processDeteccionMalezaData = (datosAnalisis, indicadores) => ({
    analisis: "DETECCION_MALEZA",
    ...datosAnalisis,
    indicadores: {
        ...indicadores,
    }
});